export default function _setParticleSystemApi(particleSystem) {
  particleSystem.emit = life => {
    const system = this.context.particleSystemArray.find(system => system.emitters[0].id === particleSystem.emitterId);
    system.emitters[0].emit(life, Infinity);
  };

  particleSystem.stopEmit = () => {
    const system = this.context.particleSystemArray.find(system => system.emitters[0].id === particleSystem.emitterId);
    system.emitters[0].stopEmit();
    particleSystem.children = [];
  };
}
